module.exports = __webpack_public_path__ + "img/Masad45.171a33c1.png";